import { render, staticRenderFns } from "./ListLinkDetail.vue?vue&type=template&id=23a317ba&"
import script from "./ListLinkDetail.vue?vue&type=script&lang=js&"
export * from "./ListLinkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports